export const objectToParams = (obj: { [key: string]: string | number }) => {
  const str: string[] = []
  // if (obj.hasOwnProperty(p)) {
  for (const p in obj)
    if (Object.prototype.hasOwnProperty.call(obj, p)) {
      const value = obj[p]
      if (value !== undefined && value !== null) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(value))
      }
    }
  return str.join('&')
}
